export type ActionBlockPresetTheme =
  | "t2-action-theme-one"
  | "t2-action-theme-two"
  | "t2-action-theme-three"
  /** Fallback from Contentful when theme is unset; no dedicated block style in terra.css */
  | "t2-action-theme-four"
  | undefined

/** Matches TerraLink button + medium size; used with disableStyles so action themes replace default yellow/gray. */
const ACTION_BUTTON_BASE =
  "rounded-full cursor-pointer inline-block font-bold text-center [text-decoration:none]! uppercase border-2 shadow-none transition-[color,background-color,border-color,opacity] duration-150 ease-in-out"

const ACTION_BUTTON_MEDIUM =
  "text-lg tracking-[1.44px] leading-7 py-4 px-9 max-sm:text-base max-sm:py-1.5 max-sm:px-[34px]"

export function getActionBlockButtonClasses(
  presetTheme: ActionBlockPresetTheme,
  isPrimary: boolean,
): string {
  const base = `${ACTION_BUTTON_BASE} ${ACTION_BUTTON_MEDIUM}`

  switch (presetTheme) {
    case "t2-action-theme-one":
      return isPrimary
        ? `${base} border-gray-m10 bg-gray-m10 text-white hover:bg-gray-m9 hover:border-gray-m9`
        : `${base} border-gray-m10 bg-transparent text-gray-m10 hover:bg-gray-m10/15`

    case "t2-action-theme-two":
      return `${base} border-white bg-transparent text-white hover:bg-white/10`

    case "t2-action-theme-three":
      return isPrimary
        ? `${base} border-gray-m10 bg-gray-m10 text-white hover:bg-gray-m9 hover:border-gray-m9`
        : `${base} border-gray-m10 bg-transparent text-gray-m10 hover:bg-gray-m10/15`

    default:
      return isPrimary
        ? `${base} border-gray-m10 bg-gray-m10 text-white hover:bg-gray-m9 hover:border-gray-m9`
        : `${base} border-gray-m10 bg-transparent text-gray-m10 hover:bg-gray-m10/15`
  }
}
